import React from 'react';

/** Kopyalanabilir salt-okunur bilgi alanı (IBAN, hesap adı, ödeme açıklaması vb.) */
const CopyField = ({
  label,
  value,
  copyValue,
  successMessage = 'Kopyalandı!',
  showAlert,
  className = ''
}) => {
  const text = copyValue ?? value ?? '';

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      showAlert('Başarılı', successMessage, 'success');
    } catch (error) {
      // Bazı webview'larda clipboard API kısıtlı olabilir
      showAlert('Kopyalanamadı', 'Bilgiyi elle seçip kopyalayabilirsiniz:\n\n' + text, 'error');
    }
  };

  return (
    <div className="mb-4 last:mb-0">
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label}
        </label>
      )}
      <div className="relative">
        <div className={`bg-white p-3 pr-12 rounded-lg border-2 border-primary text-gray-900 min-h-11 flex items-center justify-center ${className}`}>
          {value || '-'}
        </div>
        <button
          type="button"
          onClick={handleCopy}
          disabled={!text}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-2 text-gray-400 hover:text-primary transition-colors disabled:opacity-40"
          title={`${label} kopyala`}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default CopyField;
